import { render, staticRenderFns } from "./TTSCategory.vue?vue&type=template&id=abd7663a"
import script from "./TTSCategory.vue?vue&type=script&lang=ts"
export * from "./TTSCategory.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports